import _plugin_vue_export_helper_default from "../_virtual/_plugin-vue_export-helper.js";
import Layout_vue_vue_type_script_setup_true_lang_default from "./Layout.vue_vue_type_script_setup_true_lang.js";
/* empty css                                                           */
//#region src/views/Layout.vue
var Layout_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Layout_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-f1eee0af"]]);
//#endregion
export { Layout_default as default };

//# sourceMappingURL=Layout.vue.js.map